<template>
  <NumberField
    id="mealplan-terminal-id"
    :name="`${formNamespace}keystore.device_id`"
    :label="translate(`${LOCALE_PREFIX}.form.terminalId`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.terminalIdPlaceholderNumber`)"
    :disabled="!editMealPlan"
    :required="editMealPlan"
    :use-grouping="false"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
